import mock from "@/@fake-db/mock";

const data = [
    "Lat",
    "Lon",
    "Speed",
    "Height",
    "Mileage",
    "EngineOilPressure",
    "BoostPressure",
    "CoolantPressure",
    "InjectorRailPressure",
    "EngineTemperature",
    "FuelTemperature",
    "EngineRPM",
    "OnboardVoltage",
    "EngineSpeed",
    "TotalMileage",
    "AcceleratorPedalPosition",
    "LoadPercentage",
    "FuelConsumption",
    "TransportSpeedOnWheels",
    "SeatBeltCondition",
    "ServiceBrakePedalPosition",
    "TachographSpeed",
    "DailyMileage",
    "TotalEngineRunningTime",
    "DailyFuelConsumption",
    "TotalFuelConsumption",
    "AxleLoad1",
    "AxleLoad2",
    "AxleLoad3",
    "AxleLoad4",
    "AxleLoad5",
    "OilTemperature",
    "InstantOilConsumption",
    "FuelLevel",
];

mock.onGet('/indicators').reply(() => [200, data])